import React from 'react';
import { FormElement, FormListItem } from '../CommonFormComponents';
import { TrashIcon } from '../icons/TrashIcon';

/**
 * 会社ロゴの更新・表示用
 * @param {readOnly} 表示のみか
 * @param {errorMessage} エラーメッセージ
 * @param {image} 画像ファイルのｓｒｃ
 * @param {onFileUpDate} イメージファイルを更新した時の処理
 * @param {onFileDelete} メージファイルを削除した時の処理
 */
const CompanyLogo = ({
  readOnly,
  errorMessage,
  image,
  isPerson,
  onFileUpDate,
  onFileDelete,
}) => (
  <React.Fragment>
    <FormListItem label={isPerson ? 'ロゴ' : '会社ロゴ'}>
      <FormElement className='form-list__element' validate={errorMessage}>
        <div className='form-list__img'>
          <div className='img-form-thumbnail'>
            <img src={image} alt='' />
          </div>
          {!readOnly && image && (
            <button
              id='close-slide-view'
              className='btn-icon form-list__element--btn_delete'
              onClick={onFileDelete}
            >
              <TrashIcon className='icon--2_4x form-list__trash-icon' />
            </button>
          )}
        </div>
        {!readOnly && (
          <label htmlFor='file-company-branch-image' className='btn input-file'>
            ファイル選択
            <input
              type='file'
              id='file-company-branch-image'
              onChange={onFileUpDate}
              accept='image/png,image/jpeg,image/gif'
            />
          </label>
        )}
      </FormElement>
    </FormListItem>
  </React.Fragment>
);

export default CompanyLogo;



// WEBPACK FOOTER //
// ./src/components/image/CompanyLogo.jsx